import "@stimulus/polyfills";
import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";
import stimulusHelpers from "./lib/stimulus_helpers";

window.planima = window.planima || {};
window.planima.stimulusApplication = Application.start();
const controllers = import.meta.glob(
  "./stimulus_controllers/**/*_controller.{js,ts}",
  { eager: true }
);
registerControllers(stimulusHelpers.getApplication(), controllers);

// Reconnect Stimulus controllers after DOM updates (e.g., via Morphdom)
window.addEventListener("planima:DOMUpdated", ({ target }) => {
  for (const { element, context } of stimulusHelpers.getApplication()
    .controllers) {
    if (target && (target as HTMLElement)?.contains(element)) {
      // Exclude element that includes data-morphdom-ignore attribute
      if (
        ["true", ""].includes(
          (element.closest("[data-morphdom-ignore]") as HTMLElement | null)
            ?.dataset?.morphdomIgnore ?? "NONE"
        )
      ) {
        return;
      }

      context.disconnect();
      context.connect();
    }
  }
});
